import React from "react";
import cs from "classnames";
import { Icon } from "../Icon/Icon";
import { Button } from "../Button/Button";

import "./ToggleAllButton.scss";

interface Props {
  allToggled: boolean;
  onToggleAll: () => void;
  className?: string;
}

export const ToggleAllButton = ({
  allToggled,
  onToggleAll,
  className = "d-flex align-items-center",
}: Props) => {
  return (
    <div className={className}>
      <Button
        onClick={onToggleAll}
        color={allToggled ? "outline-primary" : "primary"}
        size="small"
        title={allToggled ? "Collapse All" : "Expand All"}
        icon="chevron-down"
        className={cs("ToggleAllButton", {
          ToggleAllButton__toggled: allToggled,
        })}
      />
    </div>
  );
};
